module.exports = __webpack_public_path__ + "img/icon-commitment-02.66261e5b.svg";